// extracted by mini-css-extract-plugin
export default {"indicator":"indicator_indicator__d68tE","explanation":"indicator_explanation__5HUxe","title":"indicator_title__eyap9"};